const columns = [
    {
        title: 'Name',
        dataIndex: 'name',      
    },
    {
        title: 'Email',
        dataIndex: 'email',    
        // sorter: true  
    },
    {
        title: 'Mobile No.',
        dataIndex: 'phoneNo',
    }, 
    {
        title: 'Request Date',
        dataIndex: 'createdDate',
        // sorter: true
    }, 
    {
        title: 'Action',
        dataIndex: 'action',
    }

];

export default columns;